import React, { useEffect, useState } from "react";
import { ROUTES } from "../../utils/Routes";
import { useTabs } from "../../hooks/useTabs";
import Space from "../../ui/Space";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import { InfoIcon } from "../../utils/Icons";
import Status from "../../ui/Status";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import dayjs from "dayjs";
import DateInput from "../../ui/DateInput";
import { arrayToObject, buildFileFromChunks, kbdEvent } from "../../utils/Utils";
import { pubCall } from "../../utils/PubSub";
import { showError, showMessage } from "../../ui/Message";
import { ENUMS } from "../../utils/Enums";
import { drawPicker } from "../../popovers/Picker";
import Spin from "../../ui/Spin";

export default function ProcessOrderForm(props) {

    const { controller = "", route = ROUTES.PROCESSING.ORDER_FORM, mark_as_sent = false, item = {}, callback = () => { } } = props;


    const [loading, setLoading] = useState(false);

    const sendViaCodes = {
        Rep: "R",
        Web: "W",
        Email: "E", // bypass
        Phone: "P",
        Mail: "M", // bypass
        Fax: "F", // bypass error
        Bisac: "B",
        EDI: "B",
        Net: "N",
    };

    const {
        send_via = "",
        bill_to_san = "",
        ship_to_san = "",
        ship_via = "",
        order_number = "",
        cancel_date = null,
        cancel_days = 0,
        status = "",
        internal_note = "",
        supplier = {},
        separator = "",
    } = item;
    
    const {
        edi_format = "",
        alt_bill = 0,
        alt_ship = 0,
        san = "",
        backorder = "Y",
        ship_via: supplier_ship_via = "",
        cancel_days: supplier_cancel_days = 0,
        website = "",
        email = "",
        note = "",

        warehouse = "",
        dc_pair = "",
        backorders_release = ""
    } = supplier;

    // edi_format = {

    //     X: "x12",
    //     I: "ingram",

    // }

    const {
        whCodes = "", // fourth character of the supplier code?
    } = props;


    const process = () => {
        // check for changes on the current field too
        const current = refs.current[index];
        const currentValue = current?.value;

        const _tabsObj = arrayToObject(tabs);
        const update = { ..._tabsObj, [index]: currentValue }

        const obj = {
            purchase_order_id: item?.purchase_order_id || "",
            ship_via: update?.shipVia || "",
            stock_status: (update?.stockStatus === "Y") ? true : false,
            order_number: update?.poNumber,
            backorders: update?.backorders || "N",
            cancel_by_days: update?.cancelBy || 0,
            promo_code: update?.promoCode || "",
            notes: update?.promoNote || "",
            supplier_notes: update?.supplierNote || "",
            print_copy: (update?.printOrderCopy === "Y") ? true : false,
            cascade_options: 0,
            mark_as_sent: mark_as_sent, // this is a load option
            warehouse: update?.warehouse || "",
            dc_pair: dc_pair || "",
            backorders_release: update?.boRelease || "",
        }

      
        pubCall("purchase_order.prepareOrderDocument", obj, (_s, _r) => {
            if (_s) {
                buildFileFromChunks(_r, pubCall, setLoading, () => {
                    showMessage("File created successfully.")
                })
            } else {
                showError(_r);
            }
            setLoading(false)
        })




    };


    const markAsSent = (status !== "Pend");


    const sendVia = sendViaCodes[send_via] || send_via;
    const ediFormat = edi_format.trim();
    const isIngram = (ediFormat === "I");



    const stockStatus = (sendVia === "Netftp" && isIngram);
    const isEmail = sendVia === "E";
    const isWeb = sendVia === "W";
    const isEmailFax = !markAsSent && "EF".includes(sendVia);
    const hasBillto = alt_bill > 1;
    const hasShipto = alt_ship > 1;
    
    const cancelDate = dayjs().add((cancel_days) ? cancel_days : supplier_cancel_days, "day").startOf("day").valueOf()

    const defaultTabs = [
        { key: "billto", value: alt_bill, tip: "" },
        { key: "bill_to_san", value: bill_to_san, tip: "" },

        { key: "shipto", value: alt_ship, tip: "" },
        { key: "ship_to_san", value: ship_to_san, tip: "" },

        // { key: "shipVia", value: ship_via || supplier_ship_via, tip: "Leave blank for usual shipping" },

        ...(stockStatus ? [{ key: "stockStatus", value: "", tip: "Warning! If supplier does not support Stock Status, the order will be live" }] : []),

        // ...(whCodes ? [{ key: "warehouseCode", value: "", tip: "Blank for your default warehouse (pairs) or [PgUp] to choose one" }] : []),

        ...(isIngram ? [
            { key: "warehouse", value: warehouse, tip: "Blank for your default warehouse (pairs) or [PgUp] to choose one" },
            { key: "dcPair", value: dc_pair, tip: "Blank (default) or Yes/No to check secondary warehouse for stock" },
            { key: "boRelease", value: backorders_release, tip: "Leave blank, or [R]elease (ship one book) or [H]old (ship with next order)" },
        ] : []),

        { key: "send_via", value: send_via, tip: "xxxx", skip: true },

        { key: "poNumber", value: order_number ? order_number : String(separator || "").charAt(0), tip: "Blank to assign next P0#, else use a prefix or custom PO#" },

        
        { key: "promoCode", value: "", tip: "Enter a code provided by your vendor for a special terms on this order" },
        { key: "promoNote", value: "", tip: "Add your internal notes about this promo (e.g 55% disc)" },

        { key: "supplierNote", value: internal_note, tip: "This note will be added to any printed/emailed order copy (n/a for EDI orders)" },

        ...(isEmail ? [{ key: "email", value: email, tip: "Email address [PgUp]" }] : []),
        // ...(isWeb ? [{ key: "website", value: website, tip: "xxxx" }] : []),

        { key: "backorders", value: backorder, tip: "[Y]es [No] [Backorder] only if NYR (not yet published)" },
        { key: "cancelDate", value: cancelDate, tip: "Items are cancelled if not shipped by this date" },
        { key: "cancelBy", value: cancel_days || supplier_cancel_days, tip: "Items are cancelled if not shipped within this many days (min 7)" },






        ...(isEmailFax ? [{ key: "sendOption", value: "B", tip: "S : Send only, V : Save only, B both, E edit & save" }] : []),

        { key: "printOrderCopy", value: "N", tip: "When the order is created, a copy will be printed for your files" }, // Default No
    ];

    const {
        tabs, setTabs, index, setIndex, update, updateSkip, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "poNumber");

    const getTip = () => {
        let _f = defaultTabs.find(item => item.key === index)
        return _f?.tip || ""
    }

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }

    const actions = [
        { key: KBD.ESCAPE, action: () => callback(false) },
        { key: KBD.PAGE_DOWN, action: () => process() },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.TAB, action: () => next() },
        { key: KBD.SHIFT_TAB, action: () => prev() },
    ];


    const updateCancelDays = (_days) => {
        const days = Number(_days) || 0;
        update("cancelBy", days);
        update("cancelDate", dayjs().add(days, "day").startOf("day").valueOf());
    }

    const updateCancelDate = (_date) => {
        const days = dayjs(_date).startOf("day").diff(dayjs().startOf("day"), "day");
        update("cancelBy", days);
        update("cancelDate", _date);
    }


    const selectWarehouse = (_ref, _value) => {
        blurField();
        drawPicker({
            controller: controller,
            value: _value, title: "Select Wareh", closeable: true, height: 300, ref: null, route: route, close: () => { focusField("status") }, callback: (e) => {
                if (e) {
                    update("warehouse", e)
                    setTimeout(() => {
                        kbdEvent(KBD.TAB);
                    }, 100)
                }
                focusField()
            }, offset: [0, 10],
            options: ENUMS.PROCESSING_WAREHOUSE_CODES
        })

    }


    useEffect(() => {

        if (window.bm_state.value === route) { focusField() }
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN, KBD.TAB, KBD.SHIFT_TAB]);
        return cleanup;
    }, [tabs, index])

    return (
        <>
            <Spin loading={loading}>
                <div className="shim" /><div className="shim" />
                    {/* <Space>
                        <>
                            <Label width={100}>Billto</Label>
                            <Input width={20} {...editProps("billto")} onEnter={() => next()} />
                            <Input width={100} {...editProps("bill_to_san")} onEnter={() => next()} />
                            <div className="shim" />
                        </>
                        <>
                            <Label width={50}>Shipto</Label>
                            <Input width={20} {...editProps("shipto")} onEnter={() => next()} />
                            <Input width={100} {...editProps("ship_to_san")} onEnter={() => next()} />
                            <div className="shim" />
                        </>
                    </Space>
                    <div className="shim" /> */}


                {isIngram && (
                    <>
                        <Space>

                        {stockStatus && (
                            <>
                                <Label width={100}>Stock status?</Label>
                                <Input width={20} style={{ "textAlign": "center" }} maxLength={1} chars={["Y", "N"]} tabMax={() => next()} uppercase  {...editProps("stockStatus")} onEnter={() => next()} />
                            </>
                        )}
                            <Label width={100}>Warehouse</Label>
                            <Input
                                width={20}
                                maxLength={1}
                                chars={["C", "D", "N", "E"]}
                                uppercase
                                onPageUp={() => selectWarehouse(refs.current[`warehouse`], getVal("warehouse"))}
                                doubleclick={() => selectWarehouse(refs.current[`warehouse`], getVal("warehouse"))}
                                {...editProps("warehouse")}
                                onEnter={() => next()}
                            />

                            <Label>DC Pairs</Label>

                            <Input
                                width={20}
                                maxLength={1}
                                chars={["Y", "N"]}
                                uppercase
                                {...editProps("dcPair")}
                                onEnter={() => next()}
                            />


                            <Label>BO Release</Label>
                            <Input
                                width={20}
                                maxLength={1}
                                chars={["R", "H"]}
                                uppercase
                                {...editProps("boRelease")}
                                onEnter={() => next()}
                            />
                        </Space>
                        <div className="shim" />
                    </>
                )}

                <Space>
                    <Label width={100}>{markAsSent ? "Ordered via" : "Send order via"}</Label>

                    <Input width={78} {...editProps("send_via")} onEnter={() => next()} value={send_via} className="dim" edit={false} />

                    <Label>PO#</Label>
                    <Input width={80} maxLength={5} placeholder="PO#..." {...editProps("poNumber")} onEnter={() => next()} />
                </Space>
                <div className="shim" />

                <Space>
                    <Label width={100}>Promo code</Label>
                    <Input maxLength={15} width={150} placeholder="Promo code..." {...editProps("promoCode")} onEnter={() => next()} />
                    <Label>Promo note</Label>
                    <Input width={300} placeholder="Promo note..." {...editProps("promoNote")} onEnter={() => next()} />
                </Space>
                <div className="shim" />

                <>
                    <Space>
                        <Label width={100}>Internal Note</Label>
                        <Input
                            grow
                            width={300}
                            {...editProps("supplierNote")}
                            onEnter={() => next()}
                            placeholder="Internal note..."
                        />
                    </Space>
                    <div className="shim" />
                </>

                {/* <Space>
                    <Label width={100}>Ship Via</Label>
                    <Input width={300} maxLength={16} uppercase {...editProps("shipVia")} onEnter={() => next()} placeholder="Ship via..." />
                </Space>
                <div className="shim" /> */}

                {whCodes && (
                    <>
                        <Space>
                            <Label width={80}>Warehouse code</Label>
                            <Input width={150} {...editProps("warehouseCode")} onEnter={() => next()} />
                        </Space>
                        <div className="shim" />
                    </>
                )}


                {isEmail && (
                    <>
                        <Space>
                            <Label width={100}>Email address</Label>
                            <Input
                                width={300}
                                {...editProps("email")}
                                onEnter={() => next()}
                                placeholder="Email address..."
                            />
                        </Space>
                        <div className="shim" />
                    </>
                )}

                {/* {isWeb && (
                <>
                    <Space>
                        <Label width={100}>Website</Label>
                        <Input
                            grow
                            width={"auto"}
                            {...editProps("website")}
                            onEnter={() => next()}
                            placeholder="Website URL..."
                        />
                    </Space>
                    <div className="shim" />
                </>
            )} */}

                <Space>
                    <Label width={100}>Backorders</Label>
                    <Input width={20} style={{ "textAlign": "center" }} maxLength={1} chars={["Y", "N", "B"]} tabMax={() => next()} uppercase  {...editProps("backorders")} onEnter={() => next()} />


                    <Label>Cancel date</Label>
                    <DateInput
                        width={92}
                        timestamp
                        {...editProps("cancelDate")}

                        onFilled={(date) => {
                            updateCancelDate(date);
                            next();
                        }}
                    />


                    <Input width={50} {...editProps("cancelBy")} onChange={updateCancelDays} onEnter={() => next()} />
                    <Label>days from now</Label>
                </Space>
                <div className="shim" />


                {/* {supplierNote && (
                    <>
                        <Space>
                            <Label width={100}>Supplier note</Label>
                            <Input
                                grow
                                width={300}
                                {...editProps("supplierNote")}
                                onEnter={() => next()}
                                placeholder="Supplier note..."
                            />
                        </Space>
                        <div className="shim" />
                    </>
                )} */} 

                {isEmailFax && (
                    <>
                        <Space>
                            <Label width={100}>Send option</Label>
                            <Input
                                width={20}
                                maxLength={1} allow_empty={false} chars={["S", "N", "B", "E"]}
                                uppercase
                                {...editProps("sendOption")}
                                onEnter={() => next()}
                            />
                            <Label><strong style={{ "color": "var(--text-light)" }}>S</strong> - Send only / <strong style={{ "color": "var(--text-light)" }}>V</strong> - Save only / <strong style={{ "color": "var(--text-light)" }}>B</strong> - Both / <strong style={{ "color": "var(--text-light)" }}>E</strong> - Edit, send & save</Label>
                        </Space>
                        <div className="shim" />
                    </>
                )}

                <Space>
                    <Label width={100}>Print copy?</Label>
                    <Input maxLength={1} allow_empty={false} chars={["Y", "N"]} tabMax={() => next()} uppercase width={20} style={{ "textAlign": "center" }} {...editProps("printOrderCopy")} onEnter={() => next()} />
                </Space>

                <div className="shim" /><div className="shim" />

                <Status type="active"><InfoIcon />{getTip()}</Status>
            </Spin>
        </>
    )
}